import { SossaWaveforms, SossaAmplitudeProfile, SossaMetrics } from '../components/SossaWidgets';

export const SOSSA_WIDGETS = [
  { id: 'sossaWaveforms', name: 'SOSSA Confidence Waveforms', description: 'Individual spike cards with nearby channels and SOSSA confidence', component: SossaWaveforms },
  { id: 'sossaAmplitude', name: 'SOSSA Amplitude Profile', description: 'Smooth primary-channel amplitude counts with a configurable moving average', component: SossaAmplitudeProfile },
  { id: 'sossaMetrics', name: 'SOSSA Cluster Metrics', description: 'Cluster and channel coverage, and amplitude histogram separation', component: SossaMetrics },
].map((widget, index) => ({
  ...widget, visibility: 'private', tags: ['sossa'], algorithm: 'sossa', icon: 'S', category: 'analysis',
  defaultSize: { width: 720, height: 520 }, minWidth: 400, minHeight: 280,
  requiredData: [], order: 25 + index,
}));
